import { setLoader } from '@stores/loader';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default function useLoader() {
  const dispatch = useDispatch();

  const handleProgressLoader = (text: string = '') => {
    dispatch(setLoader({ isLoading: true, text }));
  };

  const handleStopLoader = () => {
    dispatch(setLoader({ isLoading: false, text: '' }));
  };

  return { progressLoader: handleProgressLoader, stopLoader: handleStopLoader };
}
